export var removeChild = function (child, parent) {
    if (parent.contains(child)) {
        parent.removeChild(child);
    }
};
